import { createFileRoute } from '@tanstack/react-router';

import { SupplierDeliveriesPage } from '@/features/supplier/deliveries-page';

export const Route = createFileRoute('/_app/supplier/$orgId/deliveries')({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();
  return <SupplierDeliveriesPage {...params} />;
}
